import React, { useContext } from "react";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import MaskImageToggle from "../../Toggle/MaskImageToggle";
import MaskButton from "../../../../StudyList/components/Mask/MaskButton";
import "./styles.css";

const MaskImage = (props) => {
  const { maskImages } = useContext(studyviewerContext);
  

  // Inline ID creation
  const imageId = `${props.activeThumbnailIndex}_${props.currentImage}`;
  
   const isActive = !!maskImages[imageId];
  
  console.log("ImageId", imageId, isActive)
  return (
    <div className="marking-container" style={{ display: 'flex', gap: '10px' }}>
      <div className="marking-text">
        {isActive ? 'Image selected for reporting' : 'Image not selected for reporting'}
      </div>

      <MaskImageToggle isActiveImage={isActive} imageId = {imageId}/>

      {isActive && (
        <>
          <div className="separator-topbar-items" style={{ height: '15px', margin: '0px', backgroundColor:'#bfbfbf' }}></div>
          <MaskButton imageId = {imageId}/>
        </>
      )}
    </div>
  );
};

export default MaskImage;
